<div *ngIf="offsiteGroup?.length > 0" class="listing-content-section">
  <h3>Offsite Activities</h3>
  <div class="listing-icon-grid">
    <div *ngFor="let group of offsiteGroup" class="icon-wrapper">
      <div (click)="openGroup(group)" class="icon-inner-wrapper with-dropdown">
        <div class="title-wrapper">
          <div class="icon-bullet">
            <div class="w-embed">
              <curbnturf-site-svgs [type]="type"> </curbnturf-site-svgs>
            </div>
          </div>
          <div class="rift-soft-copy">{{ group.typeLabel }}</div>
        </div>
        <div *ngIf="group.open" class="dropdown-icon">
          <div class="w-embed">
            <curbnturf-misc-svg icon="dropdown"></curbnturf-misc-svg>
          </div>
        </div>
        <div *ngIf="!group.open" class="dropdown-icon">
          <div class="expanded w-embed">
            <curbnturf-misc-svg icon="dropdown"></curbnturf-misc-svg>
          </div>
        </div>
      </div>
      <ng-container *ngIf="group.open">
        <ng-container *ngFor="let activity of group.activities">
          <div (click)="openModal(activity)" class="fine-print offsite">
            {{ activity.distance }} Miles
            <span *ngIf="activity.name"> ({{ activity.name }}) </span>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
